import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['form', 'templateInput', 'entityInput', 'spinner', 'entitiesContainer']

  updateTurboConfirmContent() {
    const pattern = this.formTarget.dataset.turboConfirmPattern
    this.formTarget.dataset.turboConfirmBody = pattern
      .replace('{{template_counts}}', this.selectedTemplateCounts())
      .replace('{{entities_count}}', this.selectedEntitiesCount())
      .replace('{{requests_count}}', this.requestsToCreateCount())
  }

  selectedTemplateCounts() {
    return this.templateInputTargets.filter(input => input.checked).length
  }

  selectedEntitiesCount() {
    return this.entityInputTargets.filter(input => input.checked).length
  }

  requestsToCreateCount() {
    if (this.selectedEntitiesCount() > 0) {
      return this.selectedTemplateCounts() * this.selectedEntitiesCount()
    } else {
      return this.selectedTemplateCounts()
    }
  }

  showSpinner() {
    this.spinnerTarget.classList.remove('hidden')
    this.entitiesContainerTarget.classList.add('hidden')
  }
}
